export const SKUColumnList = {
  columns: [
    {
      id: 1,
      name: 'skuName',
      fieldName: 'skuName',
      show: true,
      sortable: true,
      removable: true,
      columnWidth: '300px',
      group: ''
    },
    {
      id: 2,
      name: 'skuDescription',
      fieldName: 'skuDescription',
      show: true,
      sortable: true,
      removable: true,
      group: ''
    },
    {
      id: 3,
      name: 'licenseUtilization',
      fieldName: 'utilizedQuantity',
      show: true,
      sortable: true,
      removable: true,
      group: ''
    },
    {
      id: 4,
      name: 'validTill',
      fieldName: 'validTill',
      show: true,
      sortable: true,
      removable: true,
      group: ''
    },
    {
      id: 5,
      name: 'orderPlacedBy',
      fieldName: 'orderPlacedBy',
      show: true,
      sortable: true,
      removable: true,
      group: ''
    },
    {
      id: 6,
      name: 'orderNumber',
      fieldName: 'orderNumber',
      show: true,
      sortable: true,
      removable: true,
      group: ''
    },
    {
      id: 7,
      name: 'subscriptionNumber',
      fieldName: 'subscriptionNumber',
      show: true,
      sortable: true,
      removable: true,
      group: ''
    },
    {
      id: 8,
      name: 'action',
      fieldName: 'action',
      show: true,
      sortable: false,
      removable: true,
      group: ''
    }
  ],
  desktopDefaultColumns: [
    'skuName',
    'skuDescription',
    'utilizedQuantity',
    'validTill',
    'orderPlacedBy',
    'action'
  ],
  tabletDefaultColumns: [
    'skuName',
    'skuDescription',
    'utilizedQuantity',
    'orderPlacedBy',
    'action'
  ],
  mobileDefaultColumns: [
    'skuName',
    'skuDescription',
    'utilizedQuantity',
    'orderPlacedBy',
    'action'
  ],
  getDefaultColumns: () => {
    return SKUColumnList.columns.filter(
      item => SKUColumnList.desktopDefaultColumns.indexOf(item.fieldName) > -1
    );
  }
};
